'use client';
import React from 'react';
import styles from './InfoBlock.module.css';

export type InfoBlockVariant = 'info' | 'warning' | 'success' | 'error' | 'neutral';

export interface InfoBlockProps {
  /**
   * Текст для отображения в блоке информации
   */
  text?: React.ReactNode;
  /**
   * Иконка для отображения слева от текста
   * По умолчанию - восклицательный знак (!)
   */
  icon?: React.ReactNode;
  /**
   * Вариант отображения блока (влияет на цвет и иконку по умолчанию)
   */
  variant?: InfoBlockVariant;
  /**
   * Дополнительный класс для стилизации
   */
  className?: string;
  /**
   * Дочерние элементы (альтернатива свойству text)
   */
  children?: React.ReactNode;
}

/**
 * Компонент для отображения информационного блока с иконкой
 */
const InfoBlock: React.FC<InfoBlockProps> = ({
  text,
  icon,
  variant = 'neutral',
  className = '',
  children,
}) => {
  // Иконки по умолчанию для каждого варианта
  const getDefaultIcon = () => {
    switch (variant) {
      case 'warning':
        return '⚠️';
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'info':
        return 'ℹ';
      case 'neutral':
      default:
        return '!';
    }
  };

  // Используем переданную иконку или иконку по умолчанию для варианта
  const displayIcon = icon !== undefined ? icon : getDefaultIcon();

  return (
      <div className={`${styles.infoBlock} ${styles[variant]} ${className}`}>
          <div className={styles.infoIcon}>{displayIcon}</div>
          <div className={styles.infoText}>{text || children}</div>
      </div>
  );
};

export default InfoBlock;
